import { useEffect, useRef } from "react";

/** Calls `onSettled` once `value` has stopped changing for `delay` ms. */
export function useDebounced<T>(value: T, delay: number, onSettled: (value: T) => void): void {
  const callback = useRef(onSettled);
  useEffect(() => {
    callback.current = onSettled;
  });

  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    const timer = setTimeout(() => callback.current(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
}
